<template>
  <div>
    <FormAddProject v-on:add-project="addProject" v-if="isAddingProject" v-on:toggle-adding-project="toggleAddingProject"></FormAddProject>
    <div class="app-container">
      <ProjectsHeader v-bind:class="{'is-adding-project' : isAddingProject }" v-on:toggle-adding-project="toggleAddingProject" v-bind:projects="projects"></ProjectsHeader>
      <div class="projects">
        <ToDoList v-for="project in reverseProjects" v-bind:key="project.id" v-bind:project="project"/>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectsHeader from "@/components/ProjectsHeader.vue";
import FormAddProject from "@/components/forms/FormAddProject.vue";
import ToDoList from "@/components/ToDoList.vue";

export default {
  name: "TodayApp",
  components: {
    FormAddProject,
    ProjectsHeader,
    ToDoList
  },
  data() {
    return {
      isAddingProject: false,
      projects: [
        {
          id: 1,
          title: "Today.app",
          githubUrl: "https://github.com/xdesro/today-app",
          todos: [
            {
              title: "Drag-n-drop",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Sorting todos by completed",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Implement icons",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Editable Titles",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Better new item submit UX",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Editable state informs whole project",
              issueNo: "",
              isDone: true,
              isEditing: false
            },
            {
              title: "Make this shit responsive",
              issueNo: "667",
              isEditing: false,
              isDone: true
            },
            {
              title: "SCSS Cleanup",
              issueNo: "1000000",
              isEditing: false,
              isDone: true
            },
            {
              title: "Adding new projects flow",
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: "Routing after auth",
              issueNo: "",
              isEditing: false,
              isDone: true
            },
            {
              title: "General Codebase Cleanup",
              issueNo: "1000001",
              isEditing: false,
              isDone: false
            },
            {
              title: "Landing Page Design",
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: "Pulling Git Repos On `Add New Project`",
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: "Editing a todo title needs UX",
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: "Better sorting",
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: 'Better "Add new project" UX',
              issueNo: "",
              isEditing: false,
              isDone: false
            },
            {
              title: "Fix authentication persistence",
              issueNo: "",
              isEditing: false,
              isDone: false
            }
          ]
        },
        {
          id: 2,
          title: "Some Test",
          githubUrl: "https://github.com/xdesro/today-app",
          todos: []
        }
      ]
    };
  },
  computed: {
    reverseProjects() {
      return this.projects.slice().reverse();
    }
  },
  watch: {
    projects: {
      handler() {
        localStorage.setItem("projects", JSON.stringify(this.projects));
      },
      deep: true
    }
  },
  mounted() {
    if (localStorage.getItem("projects")) {
      this.projects = JSON.parse(localStorage.getItem("projects"));
    }
  },
  methods: {
    toggleAddingProject() {
      this.isAddingProject = !this.isAddingProject;
      this.$emit("toggle-adding-project");
    },
    addProject(project) {
      this.projects.push(project);
    }
  }
};
</script>

<style lang="scss">
body {
  background: #000;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app-container {
  padding: 75px;
}
.projects {
  filter: blur(0px);
  opacity: 1;
  transition: all 0.2s ease;
  &:empty:before {
    content: "There are no projects yet! Click 'add new' to get started.";
    font-weight: 700;
    font-size: 20px;
  }
}
</style>
